<!-- display-mobile-15 preview — a full-screen interstitial rather than a slot on
     a publisher page: the creative across the top with its own dismiss control,
     then the advertiser mark, the headline and the description down the page,
     and the action pinned to the bottom under a hairline. There is no browser
     bar and no article text, so this is the one Display mobile placement that
     fills the whole screen. -->
<app-mobile-frame>
  <!-- START: Interstitial -->
  <div class="da-page d-flex flex-column">
    <!-- The mock leaves a white band above the creative where the phone's own
         status bar would sit. Nothing is drawn in it. -->
    <div class="da-statusbar"></div>

    <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
      <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
      <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>

      <!-- Dismiss control and AdChoices badge: both are chrome the network draws
           over the creative, so they are decorative here. -->
      <span
        class="da-close d-flex align-items-center justify-content-center"
        aria-hidden="true"
      >
        <i class="bi bi-x-lg"></i>
      </span>

      <span
        class="da-adchoices d-flex align-items-center justify-content-center"
        aria-hidden="true"
      >
        <i class="bi bi-info-circle"></i>
      </span>
    </a>

    <!-- START: Copy -->
    <!-- Takes the height the creative and the footer leave, so the copy runs
         from the top and the slack collects above the footer, as in the mock. -->
    <div class="da-body d-flex flex-column">
      <!-- GenSingleImagePreviewData carries no advertiser field, so the mark and
           the name below are literals, the same compromise the other
           placements make. -->
      <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
      <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>

      <div class="da-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </div>

      <div class="da-desc">
        {{ data.descriptions[0] || "Your description appears here" }}
      </div>

      <div class="da-advertiser">Valamar</div>
    </div>
    <!-- END: Copy -->

    <div class="da-footer">
      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta d-flex align-items-center justify-content-end">
        <span class="da-cta-label">{{ data.ctaText || "Your call to action" }}</span>
        <i class="bi bi-chevron-right"></i>
      </a>
    </div>
  </div>
  <!-- END: Interstitial -->
</app-mobile-frame>
